import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy,ChangeDetectorRef,Component,EventEmitter,inject,Input,OnDestroy,OnInit,Output } from '@angular/core';
import { FormControl,FormsModule,ReactiveFormsModule } from '@angular/forms';
import { MatLegacyAutocompleteModule as MatAutocompleteModule,MatLegacyAutocompleteSelectedEvent as MatAutocompleteSelectedEvent } from '@angular/material/legacy-autocomplete';
import { MatLegacyButtonModule } from '@angular/material/legacy-button';
import { LegacyFloatLabelType as FloatLabelType } from '@angular/material/legacy-form-field';
import { MatLegacyInputModule as MatInputModule } from '@angular/material/legacy-input';
import { LegacyPageEvent as PageEvent,MatLegacyPaginator as MatPaginator,MatLegacyPaginatorModule as MatPaginatorModule } from '@angular/material/legacy-paginator';
import { MatLegacySelectModule } from '@angular/material/legacy-select';
import { MatLegacyTooltipModule } from '@angular/material/legacy-tooltip';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { BehaviorSubject, firstValueFrom, Observable, of, Subject, Subscription, switchMap } from 'rxjs';
import { debounceTime, distinctUntilChanged, map, shareReplay, startWith, takeUntil } from 'rxjs/operators';
import { AccountsReceivableLedgerTypeEnum } from '../../../dave-data-module/entities/accounts-receivable-ledger.entity';
import { PaginatedMaterialService } from '../../../dave-data-module/services/paginated-material.service';
import { SelectSearchPagedOptionsComponent } from '../../../dave-utils-module/select-search/components/select-search-paged-options/select-search-paged-options.component';
import { SelectSearchModule } from '../../../dave-utils-module/select-search/select-search.module';
import {
    ArrayElement,
    ObservableElement,
    SearchQueriesDebounceTimeBackend,
    stringSearch,
} from '../../../helper/helper';
import { ResourcePageMeta } from '../../../helper/page-metadata';
import { ArlCalculationDataService,arlInformationInputOption,MaterialSelectSearchOption } from '../arl-calculation/arl-calculation-data.service';
import { MatOptionSelectionChange } from '@angular/material/core';

//todo zum mat form field control machen damit es in einem mat-form-field genutzt werden kann
@Component({
    selector: 'app-arl-information-input',
    standalone: true,
    imports: [
        CommonModule,
        MatAutocompleteModule,
        MatInputModule,
        ReactiveFormsModule,
        FontAwesomeModule,
        SelectSearchModule,
        FormsModule,
        MatPaginatorModule,
        SelectSearchPagedOptionsComponent,
        MatLegacyButtonModule,
        MatLegacySelectModule,
        MatLegacyTooltipModule,
    ],
    templateUrl: './arl-information-input.component.html',
    styleUrls: ['./arl-information-input.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ArlInformationInputComponent implements OnInit, OnDestroy {
    @Input() floatLabel: FloatLabelType = 'auto';
    // @Input() withOutMatFormField: boolean = false;
    @Input() informationControl!: FormControl<string>;
    protected arlType$ = new BehaviorSubject<AccountsReceivableLedgerTypeEnum | null>(null);
    @Input() set ARLType(type: AccountsReceivableLedgerTypeEnum) {
        if (type !== this.arlType$.value) {
            this.arlType$.next(type);
        }
    }
    @Output() entitySelected = new EventEmitter<{
        id: number;
        materialToSupplier?: {
            supplierId: number;
            listPrice: number;
            cost: number;
            sellPrice: number;
            articleNumber?: string;
        };
    }>();
    @Input() inputMode: 'autocomplete' | 'selectSearch' | 'pseudoSelectSearch' = 'autocomplete';
    @Input() inputClass: string = '';
    protected _entityId: number | null = null;
    @Input() set entityId(id: number) {
        this._entityId = id;
        if (id && id !== this.selectSearchForm.value?.entityId) {
            setTimeout(() => {
                // wait for arlType
                if (this.arlType$.value === AccountsReceivableLedgerTypeEnum.MaterialArl) {
                    firstValueFrom(this.arlCalculationDataService.materialOption$(id)).then((o) => {
                        this.selectSearchForm.setValue(o);
                        this.cdr.detectChanges();
                    });
                } else {
                    this.selectSearchForm.setValue({ entityId: id, value: '', optionLabel: '' });
                    this.cdr.detectChanges();
                }
            }, 0);
        }
    }

    private _pagedMaterialsService = inject(PaginatedMaterialService);
    protected materialsLoading$ = this._pagedMaterialsService.selectIsLoading$;
    options$: Observable<arlInformationInputOption[]>;
    materialAutocompleteSearchEvent$ = new Subject<{ searchQuery: string; paginator: MatPaginator }>();
    materialAutocompleteSearchEventSubscription: Subscription;
    filteredOptions$: typeof this.options$;
    protected selectSearchForm = new FormControl<arlInformationInputOption>(null);
    private readonly _destroy$ = new Subject<void>();

    placeholder = 'Bezeichnung';
    matSelectPanelClass$ = this.arlType$.pipe(map((type) => (type === AccountsReceivableLedgerTypeEnum.MaterialArl ? 'app-arl-information-input-wider-panel-class' : '')));
    constructor(private arlCalculationDataService: ArlCalculationDataService, private cdr: ChangeDetectorRef) {}

    protected compareByEntityId = (a: ArrayElement<ObservableElement<typeof this.options$>>, b: ArrayElement<ObservableElement<typeof this.options$>>) => {
        return a?.entityId === b?.entityId;
    };

    protected compareMaterialOptions = (a: MaterialSelectSearchOption | ArrayElement<MaterialSelectSearchOption['childOptions']>, b: MaterialSelectSearchOption | ArrayElement<MaterialSelectSearchOption['childOptions']>) => {
        if ((a as ArrayElement<MaterialSelectSearchOption['childOptions']>)?.supplierId && (b as ArrayElement<MaterialSelectSearchOption['childOptions']>)?.supplierId) {
            return (a as ArrayElement<MaterialSelectSearchOption['childOptions']>)?.supplierId === (b as ArrayElement<MaterialSelectSearchOption['childOptions']>)?.supplierId;
        }
        return (a as MaterialSelectSearchOption)?.entityId === (b as MaterialSelectSearchOption)?.entityId;
    };

    protected materialOptions$ = this.arlCalculationDataService.materialOptionsBySupplierId$;
    protected materialOptionsLength$ = this._pagedMaterialsService.selectLength$;

    ngOnInit(): void {
        console.log('arl-info ngOnInit');
        this.materialAutocompleteSearchEventSubscription = this.materialAutocompleteSearchEvent$.pipe(
            debounceTime(SearchQueriesDebounceTimeBackend),
            distinctUntilChanged((a, b) => {
                if(!(a.searchQuery === b.searchQuery)) {
                    console.log('arl-info notEqual', a.searchQuery, b.searchQuery)
                }
                return a.searchQuery === b.searchQuery
            }),
        ).subscribe(({ searchQuery, paginator }) => {
            this.materialSearchChange(searchQuery, paginator);
        })
        this.options$ = this.arlType$.pipe(
            distinctUntilChanged(),
            switchMap((type) =>
                type === AccountsReceivableLedgerTypeEnum.ResourceArl
                    ? this.arlCalculationDataService.resourceOptions$
                    : type === AccountsReceivableLedgerTypeEnum.EmployeeArl
                    ? this.arlCalculationDataService.employeeOptions$
                    : of([] as any),
            ),
            takeUntil(this._destroy$),
            shareReplay(1),
        );

        this.filteredOptions$ = this.options$.pipe(
            switchMap((options) =>
                this.informationControl.valueChanges.pipe(
                    startWith(null),
                    map(() => this.informationControl.value),
                    map((value) => {
                        const filterValue = (value || '').trim().toLowerCase();
                        return options.filter((option) => {
                            if (!option.optionLabel) {
                                return false;
                            }
                            if (option?.optionSearch) {
                                return option.optionSearch?.some((v) => v.includes(filterValue));
                            } else {
                                const searchContent = typeof option.optionLabel === 'string' ? option.optionLabel : (option.optionLabel as () => string)();
                                return stringSearch(searchContent, filterValue);
                            }
                        });
                    }),
                ),
            ),
        );
    }

    onDropDownSelected($event: arlInformationInputOption | MaterialSelectSearchOption['childOptions'][0]) {
        if (this.informationControl.disabled) {
            return;
        }
        console.log($event);
        this.selectSearchForm.setValue($event);
        this.selectSearchForm.markAsDirty();
        this.informationControl.setValue($event ? $event.value : '');
        this.informationControl.markAsDirty();
        this.entitySelected.emit($event ? { id: $event.entityId, materialToSupplier: ($event as MaterialSelectSearchOption['childOptions'][0]).supplierId ? ($event as MaterialSelectSearchOption['childOptions'][0]) : null } : null);
    }

    onAutocompleteSelected($event: MatAutocompleteSelectedEvent) {
        console.log($event);
        this.entitySelected.emit({ id: +$event.option.id });
    }

    protected readonly ResourcePageMeta = ResourcePageMeta;
    protected readonly AccountsReceivableLedgerTypeEnum = AccountsReceivableLedgerTypeEnum;

    pageSize$ = this._pagedMaterialsService.selectPageSize$;

    ngOnDestroy(): void {
        this.arlType$.complete();
        this._destroy$.next();
        this._destroy$.complete();
        this.materialAutocompleteSearchEventSubscription.unsubscribe();
    }

    async materialPanelOpened(searchQuery: string, paginator: MatPaginator) {
        const offset = paginator.pageIndex * paginator.pageSize;
        const currentOffset = await firstValueFrom(this._pagedMaterialsService.selectOffset$);
        const currentSearch = await firstValueFrom(this._pagedMaterialsService.selectSearchQuery$);
        if (offset !== currentOffset || (searchQuery || null) !== (currentSearch || null)) {
            this._pagedMaterialsService.setSearch(searchQuery).then(() => {
                this._pagedMaterialsService.loadPage({ offset: 0 });
                paginator.pageIndex = 0;
            });
        }
    }

    materialAutocompleteSearchChange(searchQuery: string, paginator: MatPaginator, log) {
        console.group('arl-info materialAutocompleteSearchChange ' + log);
        console.log(searchQuery);
        console.log(this.informationControl.value);
        console.log(this.informationControl.getRawValue());
        console.groupEnd()
        if (!searchQuery) {
            this.entitySelected.emit( null);
        }
        this.materialAutocompleteSearchEvent$.next({ searchQuery, paginator });
    }
    materialSearchChange(searchQuery: string, paginator: MatPaginator) {
        this._pagedMaterialsService.setSearch(searchQuery).then(() => {
            this._pagedMaterialsService.loadPage({ offset: 0 });
            paginator.pageIndex = 0;
        });
    }

    materialOptionsPageChange(page: PageEvent) {
        this._pagedMaterialsService.loadPage({
            offset: page.pageIndex * page.pageSize,
        });
    }


    onMaterialAutocompleteOptionSelected(event: MatOptionSelectionChange<string> , option: MaterialSelectSearchOption) {
        console.log(event , option)
        if (event.source.selected) {
            console.log('is selected');
            this.entitySelected.emit( { id: option.entityId, materialToSupplier: (option as MaterialSelectSearchOption['childOptions'][0]).supplierId ? (option as MaterialSelectSearchOption['childOptions'][0]) : null });
        }

        // setE
    }
}
